import printJS from 'print-js'
export function goPrintFn(header,id) {
    printJS({ printable: id,
        type: 'html',
        header,
        headerStyle: 'text-align:center;color:#f00;width:100%;',
        targetStyles: ['border', 'padding: 15px'],
        scanStyles: false,
        style: 'table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; }.top{margin-bottom:10px;}.span-text{margin-left: 26px;}' // 表格样式
    })
}